<!--
//================================================================================
// ID:BC008C3
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:BC008C3
//
// <<Modification History>>
// Version  | Date       | Updated By			 | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2022/09/26 | 富士通Japan株式会社	  | 新規作成
// 01.03.00 | 2023/02/13 | 富士通Japan株式会社    | 令和4年度改修対応（3次リリース）
// 01.04.00 | 2023/09/27 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
//================================================================================
-->
<template>
<div class="contents__main contents__main--nyukyo">
		<error-message />
		<br/>
		<h2 class="contents__h2">{{ disp.chapter }}</h2>
		<section>
			<table class="contents__table--stripe detail">
				<tbody>
					<tr class="contents__input--tr">
						<th class="contents__input--title border__bottom-none">
							氏名<span class="contents__hissu">必須</span>
						</th>
						<td class="border__bottom-none">
							<div>
								<div id="contents--name__area">
									<div>
										氏：
										<text-input
											class="contents__input--text width-name-si"
											style="ime-mode: active"
											:modelValue="fuyosyaForm.nmFuyoName1"
											:maxLength="15"
											:textType="TEXTINPUT_TYPE.FULL"
											:name="'氏名（氏）'"
											:placeholder="'例）東京'"
											:requireFlg="true"
											:groupId="'nmFuyoName'"
											@update:modelValue="fuyosyaForm.nmFuyoName1 = $event"
											ref="nmFuyoName1"
											tabindex="1"
										/>
									</div>
									<div>
										名：
										<text-input
											class="contents__input--text width-name-si"
											style="ime-mode: active"
											:modelValue="fuyosyaForm.nmFuyoName2"
											:name="'氏名（名）'"
											:maxLength="15"
											:textType="TEXTINPUT_TYPE.FULL"
											:placeholder="'例）太郎'"
											:requireFlg="true"
											:groupId="'nmFuyoName'"
											@update:modelValue="fuyosyaForm.nmFuyoName2 = $event"
											ref="nmFuyoName2"
											tabindex="2"
										/>
									</div>
								</div>
							</div>
							<itemerror-message :groupId="'nmFuyoName'"/>
						</td>
					</tr>
					<tr class="background__color--white">
						<th class="contents__input--title">
							フリガナ<span class="contents__hissu">必須</span>
						</th>
						<td>
							<div>
								<div id="contents--name__area">
									<div>
										氏：
										<text-input
											class="contents__input--text width-name-si"
											style="ime-mode: active"
											:modelValue="fuyosyaForm.nmFuyoKana1"
											:name="'フリガナ（氏）'"
											:maxLength="30"
											:textType="TEXTINPUT_TYPE.HALF_KANA"
											:placeholder="'例）ﾄｳｷｮｳ'"
											:requireFlg="true"
											:groupId="'nmFuyoKana'"
											@update:modelValue="fuyosyaForm.nmFuyoKana1 = $event"
											ref="nmFuyoKana1"
											tabindex="3"
										/>
									</div>
									<div>
										名：
										<text-input
											class="contents__input--text width-name-si"
											style="ime-mode: active"
											:modelValue="fuyosyaForm.nmFuyoKana2"
											:name="'フリガナ（名）'"
											:maxLength="30"
											:textType="TEXTINPUT_TYPE.HALF_KANA"
											:placeholder="'例）ﾀﾛｳ'"
											:requireFlg="true"
											:groupId="'nmFuyoKana'"
											@update:modelValue="fuyosyaForm.nmFuyoKana2 = $event"
											ref="nmFuyoKana2"
											tabindex="4"
										/>
									</div>
								</div>
							</div>
							<itemerror-message :groupId="'nmFuyoKana'"/>
							<div>
								<p class="contents__caution">
									※カタカナで入力してください。
								</p>
							</div>
						</td>
					</tr>
					<tr class="contents__input--tr background__color--light-gray">
						<th class="contents__input--title">
							申込者との関係<span class="contents__hissu">必須</span>
						</th>
						<td class="padding__bottom-10">
							<div>
								<list-box
									class="contents__input--select width-bosyu"
									:modelValue="fuyosyaForm.cdMoukankei"
									:name="'申込者との関係'"
									:cdType="'L0007'"
									:cdHanyo2="'1'"
									:requireFlg="true"
									:cdKbn="CD_HANDLE_TYPE.ID_CD"
									:groupId="'mouKankei'"
									@update:modelValue="fuyosyaForm.cdMoukankei = $event"
									ref="mouKankei"
									tabindex="5">
								</list-box>
							</div>
							<itemerror-message :groupId="'mouKankei'"/>
							<div class="bosyu-message">
								<caution-message
									:tyuibunItems="disp.mouKankeiTyuiItems"
								/>
							</div>
						</td>
					</tr>
					<tr class="contents__input--tr background__color--white">
						<th class="contents__input--title">
							生年月日<span class="contents__hissu">必須</span>
						</th>
						<td >
							<div>
								<date-input
									:modelValue="fuyosyaForm.dtBirthday"
									:name="'生年月日'"
									:requireFlg="true"
									:dateType="DATE_KIND.BIRTHDAY"
									:ageViewFlg="true"
									:groupId="'birthday'"
									@update:modelValue="fuyosyaForm.dtBirthday = $event"
									ref="birthday"
									tabindex="6"
								/>
							</div>
							<itemerror-message :groupId="'birthday'"/>
							<caution-message
								:tyuibunItems="disp.birthdayTyuiItems"
							/>
						</td>
					</tr>
					<tr class="contents__input--tr background__color--light-gray">
						<th class="contents__input--title">特別控除</th>
						<td>
							<div class="cond__checkbox width-madori-item">
								<check-box
									:classDiv="'width-madori'"
									:modelValue="fuyosyaForm.fgKojto"
									:cdType="'L0024'"
									:cdHanyo1="'0'"
									:name="'特別控除'"
									:classItem="'width-kojyo-range'"
									:groupId="'kojto'"
									@update:modelValue="fuyosyaForm.fgKojto = $event"
									ref="kojto"
									tabindex="9" />
							</div>
							<itemerror-message :groupId="'kojto'"/>
							<caution-message
								:tyuibunItems="disp.kojto1Items"
							/>
							<caution-message
								:tyuibunItems="disp.kojto2Items"
							/>
						</td>
					</tr>
				</tbody>
			</table>
			<br/>
			<div class="contents__div--PC">
				<div id="contents__foot--button" class="contents__div--center margin__bottom-page">
					<div class="back-marginLeft">
						<span v-if="fuyosyaForm.noFuyo == 1">
							<div id="btn--prev-pc">
								<input type="button" :value="disp.prevButtonNm" class="contents__btn--cancel btn--prev style-backbtn" @click="prev" tabindex="13"/>
							</div>
						</span>
						<span v-else>
							<div id="btn--prev-pc">
								<input type="button" :value="disp.prevButtonNm" class="contents__btn--cancel btn--prev margin-left-0px" @click="prev" tabindex="13"/>
							</div>
						</span>
					</div>
					<div class="btn-toroku">
						<input type="button" value="遠隔地扶養者入力完了" class="contents__btn--confirm btn--complete btn--complete-width" tabindex="14" @click="complete"/>
					</div>
					<div :class="[!disp.isNextButton ? 'btn--next-width' : '']" >
						<span v-if="disp.isNextButton">
							<div id="btn--next-pc">
								<input type="button" value="次の遠隔地扶養者" class="contents__btn--confirm btn--next btn-marginRight0" tabindex="15" @click="next"/>
							</div>
						</span>
					</div>
				</div>
			</div>
			<div class="contents__div--MOBILE">
				<div id="contents__foot--button" class="contents__div--center margin__bottom-page">
					<div class="back-marginLeft">
						<a v-if="fuyosyaForm.noFuyo == 1" class="contents__btn--cancel btn--prev style-backbtn" tabindex="13" @click="prev">{{ disp.prevButtonNm }}</a>
						<a v-else class="contents__btn--cancel btn--prev margin-left-0px" tabindex="13" @click="prev">{{ disp.prevButtonNm }}</a>
					</div>
					<div class="btn-toroku">
						<a class="contents__btn--confirm btn--complete btn--complete-width" tabindex="14" @click="complete">遠隔地扶養者入力完了</a>
					</div>
					<div :class="[!disp.isNextButton ? 'btn--next-width' : '']" >
						<a v-if="disp.isNextButton" class="contents__btn--confirm btn--next btn-marginRight0" tabindex="15" @click="next">次の遠隔地扶養者</a>
					</div>
				</div>
			</div>
			<br/>
		</section>
	</div>
</template>

<script>
import ErrorMessage from '@/components/ErrorMessage.vue';
import ItemErrorMessage from '@/components/ItemErrorMessage.vue';
import CautionMessage from '@/components/CautionMessage.vue';
import TextInput from '@/components/TextInput.vue';
import ListBox from '@/components/ListBox.vue';
import CheckBox from '@/components/CheckBox.vue';
import DateInput from '@/components/DateInput.vue';

import { co_post } from '@/common/ajaxUtility.js';
import { co_isEmpty } from '@/common/checkUtility';
import { co_zenkaku2Hankaku } from '@/common/stringUtility.js';
import { co_getMessage } from '@/common/messageUtility.js';
import { co_confirmDialog } from '@/common/dialogUtility.js';
import { co_toTop } from '@/common/screenUtility.js';
import { API_LIST_ITEMS } from '@/const/route.js';


import { STORE_ERROR_CLEAR, STORE_VIEW_TITLE, STORE_VIEW_PROGRESS, STORE_ERROR_SET_INPUT_ERR,
			STORE_ERROR_IS_ERRFLG, STORE_ERROR_IS_INPUT_ERRFLG } from '@/const/store.js';
import { CD_HANDLE_TYPE, DATE_KIND, TEXTINPUT_TYPE, DIALOG_BUTTON_LIST_KEY, BOSYU_HOSHIKI } from '@/const/const.js';
import { PATH_BC008_CHECK_KOJYO } from '@/const/route.js';

export default {
	name: "BC008C3",
	components: {
		'error-message': ErrorMessage,
		'itemerror-message': ItemErrorMessage,
		'caution-message' : CautionMessage,
		'text-input': TextInput,
		'list-box': ListBox,
		'check-box': CheckBox,
		'date-input': DateInput,
	},
	props: ['form'],
	data: function () {
		return {
			fuyosyaForm: {
				noFuyo: 0,						// 扶養者番号
				nmFuyoName1: '',				// 氏名（氏）
				nmFuyoName2: '',				// 氏名（名）
				nmFuyoKana1: '',				// フリガナ（氏）
				nmFuyoKana2: '',				// フリガナ（名）
				cdMoukankei: '',				// 申込者との関係
				nmMoukankei: '',				// 申込者との関係（名称）
				dtBirthday: '',					// 生年月日
				fgKojto: '',					// 特別控除
				nmKojto: '',					// 特別控除（名称）
				isInputCheck: false,			// 入力チェック結果
				viewFlg: false,					// 画面表示フラグ
			},
			disp: {
				chapter: '',					// 見出し
				mouKankeiTyuiItems: ['C0029'],	// 遠隔地扶養者申込者との関係注意文リスト
				birthdayTyuiItems: [],			// 遠隔地扶養者年齢注意文リスト
				kojto1Items: ['C0030'],			// 特別控除注意文１リスト
				kojto2Items: ['C0222'],			// 特別控除注意文２リスト
				prevButtonNm: '',				// 戻るボタン名称
				isNextButton: true,				// 次の遠隔地扶養者ボタン表示フラグ
				mouKankeiList: [],				// 申込者との関係リスト
				kojtoList: [],					// 特別控除リスト
			},
			errNoFuyo:0,						// 入力チェックエラーとなった遠隔地扶養者番号
			formC3: [],							// 入力FORM
			CD_HANDLE_TYPE: CD_HANDLE_TYPE,
			DATE_KIND:DATE_KIND,
			TEXTINPUT_TYPE: TEXTINPUT_TYPE,
			BOSYU_HOSHIKI: BOSYU_HOSHIKI,
		}
	},
	mounted: function () {
		// フォーカス設定
		this.$refs.nmFuyoName1.focus();
	},
	created: async function() {

		// エラーをクリア
		this.$store.commit(STORE_ERROR_CLEAR);

		// ローディング表示開始
		this.$store.commit(STORE_VIEW_PROGRESS, true);

		// 同機能内のパラメータ受け渡し
		this.formC3 = this.form;

		// 画面タイトル
		this.$store.commit(STORE_VIEW_TITLE, '遠隔地扶養者入力');

		// 画面項目設定
		let noFuyo = this.$route.params.noFuyo;
		this.drawFuyosyaInfo(noFuyo);

		// 申込者との関係リスト
		this.disp.mouKankeiList = await this.createNameList('L0007');

		// 特別控除リスト
		this.disp.kojtoList = await this.createNameList('L0024');

		// 遠隔地扶養者年齢注意文
		if (this.formC3.bosyuHoshiki == BOSYU_HOSHIKI.ZUIJI) {
			this.disp.birthdayTyuiItems = ['C0191'];
		} else {
			this.disp.birthdayTyuiItems = ['C0191'];
		}

		// ローディング表示終了
		this.$store.commit(STORE_VIEW_PROGRESS, false);
	},
	methods: {
		// 遠隔地扶養者情報設定
		drawFuyosyaInfo: async function (noFuyo) {

			// エラーをクリア
			this.$store.commit(STORE_ERROR_CLEAR);

			// 画面項目設定
			let fuyoInfo = this.formC3.fuyoList[noFuyo-1];
			this.fuyosyaForm = fuyoInfo;
			this.fuyosyaForm.noFuyo = Number(noFuyo);
			await this.$nextTick();
			this.$refs.birthday.setValue(this.fuyosyaForm.dtBirthday);
			
			// 画面表示フラグを変更する
			this.formC3.fuyoList[noFuyo-1].viewFlg = true;
			
			if (noFuyo > 1) {
				// 1人目以降の場合
				this.disp.chapter = '遠隔地扶養者情報（' + co_zenkaku2Hankaku(noFuyo) + '人目）';
				this.disp.prevButtonNm = '前の遠隔地扶養者';
			} else {
				this.disp.chapter = '遠隔地扶養者情報（１人目）';
				this.disp.prevButtonNm = '戻る';
			}

			if (noFuyo == this.formC3.nuFuyo || noFuyo > this.formC3.nuFuyo) {
				// 最終遠隔地扶養者の場合、次の遠隔地扶養者ボタンを表示しない
				this.disp.isNextButton = false;
			} else {
				this.disp.isNextButton = true;                                                                                                                            
			}

			// フォーカス設定
			this.$refs.nmFuyoName1.focus();

			// ページトップへ遷移
			co_toTop();
		},
		// 戻る、前の遠隔地扶養者ボタン
		prev: async function () {

			if (!await this.checkInput()) {
				// 入力チェックエラー有り
				this.fuyosyaForm.isInputCheck = false;
			} else {
				// 入力チェック実施済み
				this.fuyosyaForm.isInputCheck = true;
			}

			// 申込者との関係名称変換
			this.fuyosyaForm.nmMoukankei = this.cdToNameMoukankei(this.fuyosyaForm.cdMoukankei);

			// 特別控除名称変換
			this.fuyosyaForm.nmKojto = this.cdToNamekojto(this.fuyosyaForm.fgKojto);

			if (this.fuyosyaForm.noFuyo == 1) {

				if (this.formC3.fuyoList.length == 1
					&& !this.fuyosyaForm.isInputCheck) {
					// 遠隔地扶養者リスト再作成
					this.formC3.fuyoList.shift();
					this.$emit('addFuyosya', 1);
				}

				// 世帯の所得金額計算
				this.$emit('clacAmount');

				// 世帯情報入力画面に遷移
				this.$emit('back', 1);

			} else {

				// 遠隔地扶養者入力画面（前の遠隔地扶養者）に遷移
				this.drawFuyosyaInfo(this.fuyosyaForm.noFuyo - 1);
			}
		},
		// 遠隔地扶養者入力完了ボタン
		complete: async function () {
			// チェック処理
			if (!await this.checkInput()) return;

			// 入力チェック実施済み
			this.fuyosyaForm.isInputCheck = true;

			// 申込者との関係名称変換
			this.fuyosyaForm.nmMoukankei = this.cdToNameMoukankei(this.fuyosyaForm.cdMoukankei);

			// 特別控除名称変換
			this.fuyosyaForm.nmKojto = this.cdToNamekojto(this.fuyosyaForm.fgKojto);

			// 世帯の所得金額計算
			this.$emit('clacAmount');

			// 全遠隔地扶養者チェック
			for (let i = 0; i < this.formC3.fuyoList.length; i++) {
				let fuyosyaInfo = this.formC3.fuyoList[i];
				if (!fuyosyaInfo.isInputCheck && fuyosyaInfo.viewFlg) {
					this.errNoFuyo = fuyosyaInfo.noFuyo;
					co_confirmDialog(co_getMessage('W0015', fuyosyaInfo.noFuyo, fuyosyaInfo.noFuyo), this.deleteFuyosya);
					return;
				}
			}

			let listNo = this.formC3.fuyoList.length;
			let fuyosyaInfo = this.formC3.fuyoList[listNo - 1];
			if (this.formC3.nuFuyo > listNo && fuyosyaInfo.isInputCheck) {
				// 遠隔地扶養者リスト追加
				this.$emit('addFuyosya', listNo + 1);
			}

			// 世帯情報入力画面に遷移
			this.$emit('back', listNo);
		},
		// 次の遠隔地扶養者ボタン
		next: async function () {
			// チェック処理
			if (!await this.checkInput()) return;

			// 入力チェック済み
			this.fuyosyaForm.isInputCheck = true;

			// 申込者との関係名称変換
			this.fuyosyaForm.nmMoukankei = this.cdToNameMoukankei(this.fuyosyaForm.cdMoukankei);

			// 特別控除名称変換
			this.fuyosyaForm.nmKojto = this.cdToNamekojto(this.fuyosyaForm.fgKojto);

			let nextNo = this.fuyosyaForm.noFuyo + 1;
			if (nextNo > this.formC3.fuyoList.length) {
				// 遠隔地扶養者リスト追加
				this.$emit('addFuyosya', nextNo);
			}

			// 遠隔地扶養者入力画面（次の遠隔地扶養者）に遷移
			this.drawFuyosyaInfo(nextNo);

		},
		// 遠隔地扶養者削除
		deleteFuyosya: async function (flg) {
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				// 遠隔地扶養者リスト指定行削除
				this.$emit('deleteFuyosya', this.errNoFuyo);

				// 世帯情報入力画面に遷移
				this.$emit('back', this.errNoFuyo - 1);
			}
		},
		// 入力チェック
		checkInput: async function () {

			// エラーをクリア
			this.$store.commit(STORE_ERROR_CLEAR);

			// 単項目チェック
			this.$refs.nmFuyoName1.validate();
			this.$refs.nmFuyoName2.validate();
			this.$refs.nmFuyoKana1.validate();
			this.$refs.nmFuyoKana2.validate();
			this.$refs.mouKankei.validate();
			this.$refs.birthday.validate();
			this.$refs.kojto.validate();

			// 入力チェックエラーが存在する場合
			if (this.$store.getters[STORE_ERROR_IS_ERRFLG]) {
				return false;
			}

			// 特別障害者エラーチェック
			if (!co_isEmpty(this.fuyosyaForm.fgKojto)) {
				let kojyoList = this.fuyosyaForm.fgKojto.split(',');
				if (kojyoList.findIndex(item => item === '1') >= 0
					|| kojyoList.findIndex(item => item === '2') >= 0) {

					let params = {
						'kbBosyu' : this.formC3.kbBosyu.substring(0, 2),
						'ymBosyu' : this.formC3.ymBosyu,
						'kbZyutaku' : this.formC3.kbZyutaku,
						'noMouchiku' : this.formC3.noMouchiku,
						'dtBirthday' : this.fuyosyaForm.dtBirthday,
						'fgKojRojin' : kojyoList.findIndex(item => item === '1') >= 0 ? '1' : '0',
						'fgKojTokutei' : kojyoList.findIndex(item => item === '2') >= 0 ? '1' : '0'
					};
					let result = await co_post(PATH_BC008_CHECK_KOJYO, params);
					if(result) {
						if (this.isFocus()) this.$refs.kojto.focus();
						this.$store.commit( STORE_ERROR_SET_INPUT_ERR, {id: 'kojto', msg: co_getMessage('E0107')});
						this.$refs.kojto.setError();
					}
				}

				if (kojyoList.findIndex(item => item === '3') >= 0
					&& kojyoList.findIndex(item => item === '4') >= 0) {
					// 障害者、特別障害者が両方選択されている場合
					if (this.isFocus()) this.$refs.kojto.focus();
					this.$store.commit( STORE_ERROR_SET_INPUT_ERR, {id: 'kojto', msg: co_getMessage('E0019')});
					this.$refs.kojto.setError();
				}
			}

			// 入力チェックエラーが存在する場合
			if (this.$store.getters[STORE_ERROR_IS_ERRFLG]) {
				return false;
			}

			return true;
		},
		// 名称リスト生成
		createNameList : async function (cd) {
			let resultList = [];
			let params = { cdType: cd, cdHanyo1: '', cdHanyo2: '', cdHanyo3: '' };
			let list = await co_post( API_LIST_ITEMS, params );
			if ( list != null ) {
				for ( let i = 0; i < list.length; i++ ) {
					// リストを追加
					resultList.push( {idCd: list[i].idCd, nmCd: list[i].nmCd} );
				}
			}

			return resultList;
		},
		// コード名称変換（申込者との関係）
		cdToNameMoukankei : function (cd) {
			let index = this.disp.mouKankeiList.findIndex(item => item.idCd === cd);
			if (index < 0) return '';
			return this.disp.mouKankeiList[index].nmCd;
		},
		// コード名称変換（特別控除）
		cdToNamekojto : function (val) {
			let nmKojyo = '';

			if (!co_isEmpty(this.fuyosyaForm.fgKojto)) {
				// 特別控除を選択している場合
				let kojyoList = val.split(',').sort();
				for (let i = 0; i < kojyoList.length; i++) {
					let index = this.disp.kojtoList.findIndex(item => item.idCd === kojyoList[i]);
					if (index >= 0) {
						nmKojyo = nmKojyo + this.disp.kojtoList[index].nmCd;
						if (i != kojyoList.length - 1) {
							nmKojyo = nmKojyo + '、';
						}
					} 
				}
			}
			return nmKojyo;
		},
		// フォーカス設定必要有無を判定
		isFocus : function () {
			let inputError = this.$store.getters[STORE_ERROR_IS_INPUT_ERRFLG];
			if (!inputError) {
				return true;
			}
			return false;
		}
	}
}
</script>

<style scoped>

th {
	margin-bottom: -18px;
}

/* 端末がPCの場合 */
@media screen and (min-width: 768px) {
	.contents__main--nyukyo {
		margin-top: 80px !important;
	}

	/* フッターボタン */
	#contents__foot--button {
		display: flex;
		flex-direction: row;
	}
	#contents__foot--button :nth-child(1) {
		order: 1;
		text-align: left;
	}
	#contents__foot--button :nth-child(2) {
		order: 2;
		margin: auto;
		text-align: center;
	}
	#contents__foot--button :nth-child(3) {
		order: 3;
		text-align: right;
	}

	.btn--next-width {
		width: 8%;
	}

	.width-name-si {
		width: 76% !important;
	}
}

/* 端末がスマホの場合 */
@media screen and (max-width: 767px) {
	.contents__main--nyukyo {
		margin-top: 15px !important;
	}

	/* フッターボタン */
	#contents__foot--button {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
	}
	#contents__foot--button :nth-child(1) {
		order: 1;
		width: 48%;
		margin-bottom: 1%;
		text-align: center;
	}
	#contents__foot--button :nth-child(2) {
		order: 3;
		width: 100%;
		text-align: center;
	}
	#contents__foot--button :nth-child(3) {
		order: 2;
		width: 48%;
		margin-bottom: 1%;
		text-align: center;
	}

	.style-backbtn {
		margin-left: 0px !important;
		line-height: 36px;
	}
	.back-marginLeft {
		margin-left: 7px;
	}
	.btn-marginRight0 {
		margin-right: 0px !important;
	}
	.margin-left-0px {
		margin-left: 0px !important;
	}
}

</style>